import Preview from "./Preview";
import "./PreviewPanel.scss";

/**
 * Warning shown when the site is published.
 * @constant {string}
 */
export const PUBLISHED_WARNING_COPY =
    'Please use the "Unpublish" feature to temporarily disable the OE site and display an "under construction" page instead.';

/**
 * Right-hand panel: renders the "under construction" warning alert when the site
 * is published, or the live website preview when unpublished.
 *
 * @param {object} props
 * @param {boolean} [props.showPreview=true] - Whether preview is enabled.
 * @param {string} props.clientName - Client label.
 * @param {boolean} props.isPublished - Whether the site is published.
 * @param {Object} props.data - Current customization config.
 * @param {Record<string, boolean>} props.enabledFields - Field visibility gates.
 * @returns {import('react').JSX.Element}
 */
const PreviewPanel = ({
    showPreview = true,
    clientName,
    isPublished,
    data,
    enabledFields,
}) => {
    return (
        <div className="site-customization-preview-panel">
            <div className="site-customization-preview-panel__body">
                {isPublished ? (
                    <div
                        className="site-customization-preview-panel__warning-container"
                        role="alert"
                    >
                        <p className="site-customization-preview-panel__warning">
                            {PUBLISHED_WARNING_COPY}
                        </p>
                    </div>
                ) : showPreview ? (
                    <Preview
                        data={data}
                        enabledFields={enabledFields}
                        clientName={clientName}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default PreviewPanel;
